import { Dialog } from "@mui/material"
import { CreateComponent } from "components/utils/CreateComponent"
import { createElement, useEffect, useState } from "react"
import { rootStore } from "store/RootStore"
import closeModalSvg from "img/recordings/close_modal.svg"

import "./confirmationDialog.css"

export const ConfirmationDialog = CreateComponent(null, false, false, ({ classes, title, bodyButtons, bottomButtons, onCloseHandler, children, ...props }) => {
	console.debug("ConfirmationDialog", window.innerWidth, bottomButtons, children, props)

	const widthBreak = 540
	const dialogWidthNormal = 360
	// MuiPaper has left and right margin of 32px each
	const dialogWidthSmallAdjust = 64
	const dialogButtonWidthNormal = 328
	const dialogButtonWidthSmallAdjust = 64 + 32

	const [innerWidth, setInnerWidth] = useState(window.innerWidth)
	useEffect(() => {
		window.addEventListener("resize", handleResize)
		return () => {
			window.removeEventListener("resize", handleResize)
		}
	}, [])
	const handleResize = () => {
		setInnerWidth(window.innerWidth)
	}

	return (
		<Dialog open={true} /*transition */
			placement="bottom-end"
			// MTVW-988: close on backdrop click
			disableBackdropClick="false"
			onClose={(event, reason) => {
				event.preventDefault()
				event.stopPropagation()
				if (reason === "backdropClick" || reason === "escapeKeyDown") {
					//console.debug("closing confirmation dialog", event, reason)
					onCloseHandler()
				}
			}}
			sx={{
				zIndex: "1500 !important", // higher than OverlayEventDetails!
				"& .MuiDialog-container": {
					"& .MuiPaper-root": {
						//width: "360px",
						//height: "260px",
						//overflow: "visible",
						//margin: "unset",
						//padding: "unset"
					},
				},
				"& .MuiDialog-paper": {
					borderRadius: "16px",
					//boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
					//border: "2px #595959 solid"
				},
				"& .MuiModal-backdrop": {
					backgroundColor: 'rgba(48,48,48,0.8)',
				},
			}}
			//overlayStyle={{ backgroundColor: "#4C4C4C" }}
			// moved to .MuiModal-backdrop above
			//BackdropProps={{ style: { backgroundColor: "rgba(48,48,48,0.8)" } }}
			disablePortal={rootStore.page.Player.player.isFullScreen}
			data-test="vert_window">
			{/*{({ TransitionProps }) => (
				<Slide {...TransitionProps} timeout={350} direction="up">*/}

			<div className="ConfirmationDialog" style={{ width: innerWidth <= widthBreak ? innerWidth - dialogWidthSmallAdjust : dialogWidthNormal }}>
				<div className="ConfirmationCloseContainer" data-test="cancel " onClick={() => onCloseHandler()}>
					<img className="ConfirmationCloseIcon" src={closeModalSvg}></img>
				</div>
				<div className="ConfirmationTitleFrame">
					<div className="ConfirmationTitleContainer">
						<div className="ConfirmationTitleText">{title}</div>
					</div>
				</div>
				<div className="ConfirmationDescriptionFrame">
					<div className="ConfirmationDescriptionContainer">
						<div className="ConfirmationDescriptionText" style={{ whiteSpace: "pre-line" }}>{children}</div>
					</div>
				</div>

				<div className="ConfirmationBodyButtonsSection">
					{bodyButtons &&
						bodyButtons.map((item, ix) => {
							if (item?.props) {
								item.props.inModal = true
								item.props.width = innerWidth <= widthBreak ? innerWidth - dialogButtonWidthSmallAdjust : dialogButtonWidthNormal
								//console.debug("item.props", item.props)
							}
							if (item?.bType) return <div key={ix}>{createElement(item.bType, item.props, null)}</div>
						})
					}
				</div>
				<div className="ConfirmationBottomButtonsSection">
					{bottomButtons &&
						bottomButtons.map((item, ix) => {
							if (item?.props) {
								item.props.inModal = true
								item.props.width = innerWidth <= widthBreak ? innerWidth - dialogButtonWidthSmallAdjust : dialogButtonWidthNormal
								//console.debug("item.props", item.props)
							}
							if (item.bType) return <div key={ix}>{createElement(item.bType, item.props, null)}</div>
						})
					}
				</div>
			</div>
			{/*</Slide>
			)}*/}
		</Dialog>
	)
})
